"use strict";

angular.module("extra2App").directive("ckRollingmodels", [
  "$location",
  "restservice",
  "$translatePartialLoader",
  "$translate",
  "koppenservice",
  "adminservice",
  function (
    $location,
    restservice,
    $translatePartialLoader,
    $translate,
    koppenservice,
    adminservice,
  ) {
    return {
      templateUrl: "views/directives/rolling-models.html",
      restrict: "E",
      scope: { module: "=" },
      link: function (scope) {
        $translatePartialLoader.addPart("rollingmodels");
        $translate.refresh();

        scope.hiddenBUs = ["PL", "LT", "LV", "EE", "DK", "NO"];

        // Inicjalizacja BU
        var initialBu = (
          adminservice.getBu() ||
          localStorage.getItem("businessUnit") ||
          ""
        ).toUpperCase();
        scope.bu = initialBu;
        scope.isElementDisplayed = !scope.hiddenBUs.includes(scope.bu);

        scope.$watch(
          function () {
            return adminservice.getBu() || localStorage.getItem("businessUnit");
          },
          function (newBu) {
            if (newBu && newBu.toUpperCase() !== scope.bu) {
              scope.bu = newBu.toUpperCase();
              scope.isElementDisplayed = !scope.hiddenBUs.includes(scope.bu);
            }
          },
        );

        scope.rollingModels =
          (scope.module && scope.module[1] && scope.module[1].values) || [];

        scope.$watch(
          "module[1].values",
          function (newValues) {
            if (newValues) {
              scope.rollingModels = newValues;
              scope.koppen = koppenservice.getKoppen(newValues);
            }
          },
          true,
        );

        scope.iconsBasePath = restservice.getIconsBasePath();

        scope.showRollingDetails = function (item) {
          item.iconsBasePath = scope.iconsBasePath;
          localStorage.setItem("rolling_model", JSON.stringify(item));
          $location.path("rolling-models-detail");
        };
      },
    };
  },
]);
